import styled from "styled-components";
import { Link } from '../Link/Link';
import { ButtonLink } from "../ButtonLink/ButtonLink";
import { FaLinkedin, FaTwitter } from "react-icons/fa6";

const StyledFooterWrapper = styled.footer`
  position: relative;
  z-index: 1;
`;

const StyledFooter = styled.section`
  background: hsl(0, 0.00%, 91.80%);
  color: rgb(114, 114, 114);
  padding: 20px 0;
  border-top: 3px solid rgba(255,255,255,0.08);

  h3 {
    color: rgb(158, 13, 61);
    font-size: 1.25rem;
    margin-bottom: 0px;
  }

  .links-list {
    display: flex;
    flex-direction: row;
    gap: 16px;

    a {
      color: rgb(114, 114, 114);
      transition: color 0.1s ease-out;

      &:hover {
        color: rgb(253, 177, 47);
      }
    }
  }
`;

const StyledIcons = styled.nav`
  display: flex;
  gap: 14px;
  align-items: center;

  a {
    font-size: 1.1rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
    }
  }
`;

const StyledCopyright = styled.section`
  background: #18243b;
  color: #8e8e8e;
  padding: 15px 0;

  .copyright-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .links {
    color: #fcb12d;
  }

  p {
    margin: 0;
  }

  @media (max-width: 768px) {
    .copyright-wrapper {
      flex-direction: column;
      gap: 10px;
      text-align: center;
    }
  }
`;

export const Footer = () => {
  return (
    <StyledFooterWrapper>
      <StyledFooter>
        <div className="container">
          <div className="row align-items-start text-start">
            <div className="col-md-6 my-auto">
            <div className="flex gap-4 align-items-center">
            <h3>Useful Links</h3>
              <div className="links-list">
                <Link to="https://securitybulldog.com/about/" label="About Us" external minimal />
                <Link to="https://securitybulldog.com/contact/" label="Contact Us" external minimal />
              </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="flex gap-4 align-items-center justify-content-end px-3">
              <h3>Stay Connected</h3>
              <StyledIcons>
                <ButtonLink to="https://www.linkedin.com/company/the-security-bulldog" variant="primary" rounded external target="_blank">
                  <FaLinkedin />
                </ButtonLink>

                <ButtonLink to="https://x.com/SecurityBDog" variant="primary" rounded external target="_blank">
                  <FaTwitter />
                </ButtonLink>
              </StyledIcons>
              </div>
            </div>

          </div>
        </div>
      </StyledFooter>

      <StyledCopyright>
        <div className="container">
          <div className="row">
            <div className="col-12 copyright-wrapper">
            <p style={{ color: 'white' }}>
                Copyright <span style={{ fontSize: '1.2em', verticalAlign: 'middle' }}>©</span>{' '}
                {new Date().getFullYear()} - Security Bulldog
              </p>
              <div className="links">
                <Link to="https://securitybulldog.com/privacy-policy/" label="Privacy Policy" external highlight /> |
                <Link to="https://securitybulldog.com/terms-of-service/" label="Terms of Service" external highlight />
              </div>
            </div>
          </div>
        </div>
      </StyledCopyright>
    </StyledFooterWrapper>
  )
}